import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { SettingsService } from '@core/services/settings.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login-callback',
  imports: [],
  standalone: true,
  templateUrl: './login-callback.component.html',
  styleUrl: './login-callback.component.css'
})
export class LoginCallbackComponent implements OnInit, OnDestroy {
  stream: Subscription;
  private loadingTimeout: any;
  constructor(
    private authService: AuthService,
    private router: Router,
    public settingsService: SettingsService
  ) {
    
  }

  public async ngOnInit() {
    // Start a 10-second timeout for loading
    this.loadingTimeout = setTimeout(() => {
      // Redirect to the home page if loading takes longer than 10 seconds
      this.router.navigate(['/']);
    }, 10000);

    this.stream = this.authService.canActivateProtectedRoutes$.subscribe(
      (x) => (yes) => {
        clearTimeout(this.loadingTimeout);
        if (yes) {
          return this.router.navigate(['/']);
        }
        else return this.router.navigate(['/']);
      }
    );
  }

  public ngOnDestroy() {
    clearTimeout(this.loadingTimeout);
    this.stream?.unsubscribe();
  }
}
